// error.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ErrorState } from '../states/error.state';

export const selectErrorState = createFeatureSelector<ErrorState>('error');

export const selectError = createSelector(selectErrorState, (state: ErrorState) => {
  console.log('[sbvp_gui] ErrorSelector', state);
  return state.error;
});
